import './styles/app.css';
import { registerSW } from 'virtual:pwa-register';
import { QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router/dom';
import { Toaster, toast } from 'sonner';
import { router } from './app/router';
import { queryClient } from './lib/query';
import { ReauthProvider } from './lib/reauth';
import { applyTheme } from './lib/theme';

applyTheme();

const updateSW = registerSW({
  immediate: true,
  onNeedRefresh() {
    toast('È pronta una nuova versione di Regia', {
      duration: Number.POSITIVE_INFINITY,
      action: { label: 'Aggiorna', onClick: () => updateSW(true) },
    });
  },
});

const root = document.getElementById('root');
if (!root) throw new Error('Elemento #root mancante');

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ReauthProvider>
        <RouterProvider router={router} />
      </ReauthProvider>
      <Toaster
        position="top-center"
        offset={{ top: 'calc(env(safe-area-inset-top) + 12px)' }}
        toastOptions={{
          classNames: {
            toast:
              '!rounded-2xl !bg-ink !text-sheet !border-0 !shadow-[var(--shadow-lift)] !font-sans !text-[0.9375rem]',
            actionButton: '!bg-sheet !text-ink !font-semibold !rounded-lg',
          },
        }}
      />
    </QueryClientProvider>
  </StrictMode>,
);
